"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelLayout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const Wrap = app_1.styled.div `
  padding: ${(theme) => theme.spacing.medium};
  display: flex;
  flex-direction: column;
  height: 100%;
`;
function PanelLayout({ children, className, }) {
    return (0, jsx_runtime_1.jsx)(Wrap, Object.assign({ className: className }, { children: children }));
}
exports.PanelLayout = PanelLayout;
